export default [
  {
    path: "*",
    meta: {
      public: true
    },
    redirect: {
      path: "/404"
    }
  },
  {
    path: "/404",
    meta: {
      public: true
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/NotFound.vue`
      )
  },
  {
    path: "/403",
    meta: {
      public: true
    },
    name: "AccessDenied",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/Deny.vue`
      )
  },
  {
    path: "/500",
    meta: {
      public: true
    },
    name: "ServerError",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/Error.vue`
      )
  },
  {
    path: "/logout",
    meta: {
      public: true
    },
    name: "logout",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/Logout.vue`
      )
  },
  {
    path: "/",
    meta: {},
    name: "Root",
    redirect: {
      name: "Dashboard"
    }
  },
  {
    path: "/dashboard",
    meta: { breadcrumb: false },
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/dashboard/Dashboard.vue`
      )
  },
  {
    path: "/profile",
    meta: { breadcrumb: false },
    name: "profile",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/profile/Form.vue`
      )
  },
  {
    path: "/questionary/:id",
    meta: { breadcrumb: false },
    name: "questionary",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/questionary/Form.vue`
      )
  },
  {
    path: "/questionary",
    meta: { breadcrumb: false },
    name: "questionary_all",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/public_app/pages/questionary/List.vue`
      )
  },
  {
    path: "/videozone",
    meta: { breadcrumb: false },
    name: "videozone",
    component: () => import(`@/public_app/pages/videozone/List.vue`)
  },
  {
    path: "/video/:id",
    meta: { breadcrumb: false },
    name: "video",
    components: {
      default: () => import(`@/public_app/pages/videozone/Video.vue`),
      sidemenu: () => import("@/public_app/pages/videozone/VideoSidebar.vue")
    }
  },

  {
    path: "/feedback_all",
    meta: { breadcrumb: false },
    name: "feedback_all",
    components: {
      default: () => import(`@/public_app/pages/feedback/ListFeedbacks.vue`),
      sidemenu: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          "@/public_app/pages/feedback/FeedbackSidebar.vue"
        )
    },
    props: { default: true, sidemenu: true }
  },

  {
    path: "/feedback_persons/:id",
    meta: { breadcrumb: false },
    name: "feedback_persons",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/public_app/pages/feedback/FeedbackPersons.vue`
        ),
      sidemenu: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          "@/public_app/pages/feedback/FeedbackSidebar.vue"
        )
    },
    props: { default: true, sidemenu: true }
  },
  {
    path: "/feedback_edit/:courseId",
    meta: { breadcrumb: false },
    name: "feedback_edit",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/public_app/pages/feedback/FeedbackEdit.vue`
        ),
      sidemenu: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          "@/public_app/pages/feedback/FeedbackSidebar.vue"
        )
    },
    props: { default: true, sidemenu: true }
  },
  {
    path: "/feedbacks/:courseId/relations/:relationId/:evaluatedName/:roleId?",
    meta: { breadcrumb: false },
    name: "feedback",
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/public_app/pages/feedback/Feedback.vue`
        ),
      sidemenu: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          "@/public_app/pages/feedback/FeedbackSidebar.vue"
        )
    },
    props: { default: true, sidemenu: true }
  }
];



// WEBPACK FOOTER //
// ./src/public_app/router/paths.js